export default "__VITE_ASSET__DA7wy1vs__"